import { useEffect, useState } from "react";
type Task = {
  id: string;
  meeting_id: string;
  family_id: string;
  description: string;
  status: string;
  comments: string;
  original_meeting_id: string;
  completed_at: string | null;
  created_at: string;
  updated_at: string;
  name: string;
};

export default function OpenTasksCounter() {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllTasks = async () => {
      try {
        const response = await fetch("/api/tasks/getAllTasks");
        if (!response.ok) throw new Error("שגיאה בטעינת המשימות");
        const data = await response.json();
        setTasks(data);
      } catch (err) {
        console.error("❌ שגיאה:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllTasks();
  }, []);

  const openTasksCount = tasks.filter((task) => task.status === "בתהליך").length;

  return (
    <div className="flex flex-col justify-center items-center min-h-[200px] px-4">
  {loading ? (
    <div className="text-lg text-gray-600">טוען נתונים...</div>
  ) : (
    <>
      <h2 className="text-2xl font-bold text-primary mb-2">משימות פתוחות</h2>
      <p className="text-5xl font-extrabold text-primary-dark">{openTasksCount}</p>
      <p className="text-sm text-gray-600 mt-2">סה״כ משימות במצב פעיל</p>
    </>
  )}
</div>
  );
}